import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=1031d996&scoped=true&"
import script from "./createDialog.vue?vue&type=script&lang=js&"
export * from "./createDialog.vue?vue&type=script&lang=js&"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=1031d996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031d996",
  null
  
)

export default component.exports